import type { Shell, EntryPoint } from '#packages/apilib';
import { createEditorPointerApi } from './api';
import { EditorPointerApiKey } from './publicApiKey';

export const EditorPointerEntrypoint: EntryPoint = {
  name: 'Editor Pointer API',
  declareAPIs: () => [EditorPointerApiKey],
  attach(shell: Shell) {
    shell.contributeAPI(EditorPointerApiKey, () => createEditorPointerApi());
  },
};
